
export enum Path {
  Home = '/',
  Home2 = '/home',
  About = '/about',
  ContactUs = '/contact',
  Carts = '/carts',
  Checkout = '/checkout',

  Signup = '/auth/register',
  Signin = '/auth',
  Buying = '/buying',
  Selling = 'selling',
  ForgotPassword = '/auth/forgot-password',
  // ResetPassword = '/auth/reset-password',

  //USER DASHBOARD
  UserDashboard = '/auth/dashboard',
  VendorDashboard = '/auth/vendor/dashboard',
  VendorPayment = '/auth/vendor/payments',
  VendorCarHistory = "/auth/vendor/car-history",
  VendorOrdersHistory = "/auth/vendor/orders-history",
  VendorUserSettings = "/auth/vendor/vendor-settings",


  Upgrade = '/auth/upgrade',
  Terms = '/terms-and-conditions',
  Privacy = '/privacy-policy',
  // UserLearn = '/auth/learn',
  // UserEarn = '/auth/earn',
  // UserSettings = '/auth/settings',
  // UserNft = '/auth/nft',
  // UserTrade = '/auth/trade',
  //  UserWallet = '/auth/wallet' 
}
